import { render, staticRenderFns } from "./PaymentMethodProviderTestMode.vue?vue&type=template&id=6ef2d529&"
import script from "./PaymentMethodProviderTestMode.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodProviderTestMode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports